// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-email-cta-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}

.verify-email-cta-button {
  background-color: cadetblue;
  padding: 20px;
  border-radius: 5px;
}

.verify-email-cta-button:hover {
  background-color: darkcyan;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/VerifyEmailCta/VerifyEmailCta.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".verify-email-cta-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n}\n\n.verify-email-cta-button {\n  background-color: cadetblue;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.verify-email-cta-button:hover {\n  background-color: darkcyan;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
